import React, { useRef, useState } from "react";
import IOSSwitch from "./toggle";

function IntegrationsPage() {
  const handleUpdate = (index, features) => {
    // setLayer1Array((prevArray) => {
    //   const newArray = [...prevArray];
    //   newArray[index].status = !newArray[index].status;
    //   return newArray;
    // });
    setLayer1Array((prevArray) => {
      return prevArray.map((item, i) => {
        if (i === index) {
          return { ...item, status: !item.status };
        }
        return item;
      });
    });
  };

  const [layer1Array, setLayer1Array] = useState([
    {
      integration: "Onemoney, Finvu, CAMS, NADL, Protean",
      productSuite: "Switch for AAs",
      features: `Bank Statements, Salary, MFs, Stocks, Bonds, FDs, GST, NPS`,
      status: true,
      rowSpan: 2,
      rowSpanProduct: 2,
    },
    {
      integration: "",
      productSuite: "",
      features: `
          Switches amongst best AA based on asset type selection`,
      status: true,
    },
    {
      integration: "CAMS",
      rowSpan: 2,
      productSuite: "CAS",
      features: "Mutual Funds - Insurance",
      status: true,
    },
    {
      integration: "",

      productSuite: "LAMF",
      features: "Pledge, Invoke, Revoke",
      status: false,
    },
    {
      integration: "KFintech",
      rowSpan: 2,
      productSuite: "CAS",
      features: "Mutual Funds - AIFs",
      status: false,
    },
    {
      integration: "",

      productSuite: "LAMF",
      features: "Pledge, Invoke, Revoke",
      status: true,
    },
    {
      integration: "MF Central",
      rowSpan: 4,
      productSuite: "LAMF",
      features: "Pledge, Invoke, Revoke",
      status: false,
    },
    {
      integration: "",

      productSuite: "CAS",
      features: "MFs - AIFs, Insurance",
      status: true,
    },
    {
      integration: "",

      productSuite: "Capital Gains",
      features: "Mutual Funds",
      status: true,
    },
    {
      integration: "",
      productSuite: "NCT",
      features: "Nominee Change, Account Updation",
      status: true,
    },
    {
      integration: "NSDL",
      rowSpan: 3,
      productSuite: "CAS",
      features: "Stocks, Bonds, ETF, Reits, G-secs",
      status: true,
    },

    {
      integration: "",
      productSuite: "TP-LAS",
      features: "Pledge, Invoke, Revoke",
      status: true,
    },
    {
      integration: "",
      productSuite: "DP-LAS",
      features: "Pledge, Invoke, Revoke",
      status: true,
    },
    {
      integration: "CDSL",
      rowSpan: 2,
      productSuite: "CAS",
      features: "Stocks & Bonds",
      status: false,
    },

    {
      integration: "",
      productSuite: "E-LAS",
      features: "Pledge, Invoke, Revoke",
      status: false,
    },
    {
      integration: "One Vahaan",
      rowSpan: 2,
      productSuite: "Vehicle Detailed",
      features: "50+ Data Points on Vehicle",
      status: true,
    },

    {
      integration: "",
      productSuite: "Vehicle Challan",
      features: "10+ Data Points on Challans",
      status: true,
    },
    {
      integration: "Insured Declared Value & Market Price",
      productSuite: "Vehicle Valuation",
      features: "Market Value, Loan-to-Value & IDV Fetch",
      status: true,
    },
    {
      integration: "Vehicle 360° View",
      productSuite: "3D Rendering Vehicles",
      features: "360° View of Vehicle - 2 & 4 Wheelers",
      status: true,
    },
    {
      integration: "Tartan",
      rowSpan: 2,
      productSuite: "Payslip",
      features: "Detailed Payslip Details ",
      status: false,
    },
    {
      integration: "",
      productSuite: "EPFO",
      features: "Detailed EPFO Details Fetch",
      status: false,
    },
    {
      integration: "Corpository",
      rowSpan: 3,
      productSuite: "GST",
      features: "Detailed GST Report via GST Portal",
      status: false,
    },

    {
      integration: "",
      productSuite: "ITR",
      features: "Detailed ITR Report via ITR Portal",
      status: false,
    },
    {
      integration: "",
      productSuite: "MCA",
      features: "Detailed MCA Report via MCA Portal",
      status: true,
    },
    {
      integration: "Bureau ID",
      productSuite: "Alternative KYC",
      features: "Alternative Risk Scoring & KYC Report",
      status: true,
    },
    {
      integration: "Credit Bureau",
      rowSpan: 2,
      productSuite: "Cibil",
      features: "Credit Score & Reports",
      status: true,
    },

    {
      integration: "",
      productSuite: "Experian",
      features: "Credit Score & Reports",
      status: true,
    },
    {
      integration: "Propstack",
      productSuite: "Cibil",
      features: `Real Estate Beneficial Ownership Report`,
      rowSpan: 2,
      rowSpanProduct: 2,
      status: true,
    },
    {
      integration: "",

      productSuite: "",
      features: `Real Estate Transactions Report`,
      status: false,
    },
    {
      integration: "SRO Stack",
      productSuite: "Real Estate Valuation",
      features: "Pincode Wise Property Valuation",
      status: false,
    },
    {
      integration: "Lending Suite",
      rowSpan: 4,
      productSuite: "Razorpay",
      features: "Tech Integrations",
      status: true,
    },

    {
      integration: "",
      productSuite: "Yes Bank",
      features: "Banking Disbursals",
      status: false,
    },
    {
      integration: "",
      productSuite: "Easebuzz",
      features: "Banking Repayments",
      status: false,
    },
    {
      integration: "",
      productSuite: "Digio",
      features: "KYC Suite",
      status: false,
    },

    {
      integration: "MCA",
      productSuite: "Intangible Assets, Goodwill, Trademarks & Inventory",
      features: "",
      status: true,
    },
    {
      integration: "Bank Accounts",
      productSuite: "Consumer Durables Assets",
      features: "",
      status: false,
    },
    {
      integration: "BharatPe",
      productSuite: "Utilities",
      features: "",
      status: true,
    },
    {
      integration: "LinkedIn",
      productSuite: "Education, Work Experience ",
      features: "",
      status: true,
    },
  ]);

  return (
    <div className="userlist-table-div flex  justify-between">
      <table className="userlist-table api-table">
        <thead className="!h-[30px]">
          <tr>
            <th>Integrations</th>
            <th>Partnership product suite</th>
            <th>Types/Features</th>
            <th>STATUS</th>
          </tr>
        </thead>
        {layer1Array.map((item, index) => {
          return (
            <tr className="right-border transaction">
              {item.integration && (
                <td rowSpan={item.rowSpan}>{item.integration}</td>
              )}
              {item.productSuite && (
                <td rowSpan={item.rowSpanProduct}>{item.productSuite}</td>
              )}
              <td>{item.features}</td>
              <td>
                <IOSSwitch
                  checked={item.status}
                  onClick={() => {
                    console.log(index);
                    handleUpdate(index, item.features);
                  }}
                />
              </td>
            </tr>
          );
        })}
      </table>
    </div>
  );
}

export default IntegrationsPage;
